(function () {
  var allowed = new Set(['2-4 weeks', '4-6 weeks', '6-8 weeks', '8-12 weeks']);
  class GCCustomOrder extends HTMLElement {
    connectedCallback() {
      if (this._events) this._events.abort();
      this._events = new AbortController();
      this._readVariants(this);
      this._render(this.dataset.leadTime);
      document.addEventListener('variant:change:' + this.dataset.sectionId + ':' + this.dataset.productId,
        this._onVariantChange.bind(this), { signal: this._events.signal });
      document.addEventListener('variantChange', this._onLegacyVariantChange.bind(this), { signal: this._events.signal });
    }
    disconnectedCallback() { if (this._events) this._events.abort(); }
    _readVariants(source) {
      try { this._variants = JSON.parse(source.querySelector('[data-gc-variant-times]')?.textContent || '{}'); }
      catch (_) { this._variants = {}; }
    }
    _render(value) {
      var valid = allowed.has(value);
      this.hidden = !valid;
      this.dataset.leadTime = valid ? value : '';
      var text = this.querySelector('[data-gc-lead-time]');
      if (text) text.textContent = valid ? value.replace('-', '–') : '';
      if (!valid) { var details = this.querySelector('details'); if (details) details.open = false; }
    }
    _onVariantChange(event) {
      var detail = event.detail || {};
      if (!detail.variant) { this._selectedVariant = null; this._render(''); return; }
      var id = String(detail.variant.id);
      if (detail.loading) this._selectedVariant = id;
      else if (this._selectedVariant !== undefined && this._selectedVariant !== id) return;
      var updated = !detail.loading && detail.html?.getElementById(this.id);
      if (updated && String(updated.dataset.variantId) === id) {
        this.dataset.defaultTime = updated.dataset.defaultTime || '';
        this._readVariants(updated);
        this._render(updated.dataset.leadTime);
      } else if (Object.prototype.hasOwnProperty.call(this._variants, id)) {
        this._render(this._variants[id] || this.dataset.defaultTime);
      } else {
        this._render('');
      }
    }
    _onLegacyVariantChange(event) {
      var detail = event.detail || {};
      if (String(detail.sectionId) !== this.dataset.sectionId) return;
      if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
      this._onVariantChange(event);
    }
  }
  if (!customElements.get('gc-custom-order')) customElements.define('gc-custom-order', GCCustomOrder);
  document.addEventListener('change', function (event) {
    var widthControl = event.target.closest('[data-gc-review-width]');
    if (widthControl) {
      var review = widthControl.closest('.gc-custom-order-review');
      review.style.maxWidth = widthControl.value === 'full' ? '' : widthControl.value + 'px';
      return;
    }
    var select = event.target.closest('[data-gc-review-variant]');
    if (!select) return;
    var variant = select.value === 'none' ? null : { id: select.value };
    document.dispatchEvent(new CustomEvent('variant:change:gc-review:demo', { detail: { variant: variant, loading: true } }));
    document.dispatchEvent(new CustomEvent('variant:change:gc-review:demo', { detail: { variant: variant, loading: false } }));
  });
})();
